import React, { ReactElement, createRef, RefObject } from 'react';
import { isEven, isMobile, isVisible } from '../const/util';
import styles from '../assets/styles/projects.module.scss';

import ImageBox from './imageBox';
import TextBox from './textBox';
import { ProjectData } from '../interfaces';

export default class Dynamic extends React.Component<ProjectData, {
	focused: boolean
}> {

	private container: RefObject<HTMLDivElement> = createRef();
	public state = {
		focused: false
	}

	private handleScroll = (): void => {
		let div = this.container.current;
		if (!div) return;
		if (isVisible(div) && !this.state.focused) {
			this.setState({ focused: true });
		} else 
		if (!isVisible(div) && this.state.focused) {
			this.setState({ focused: false });
		}
	}

	componentDidUpdate() {
		let div = this.container.current;
		if (!div) return;
		if (this.state.focused) {
			div.classList.add(styles.focus);
			div.classList.remove(styles.unfocus);
		} else {
			div.classList.remove(styles.focus);
			div.classList.add(styles.unfocus);
		};
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.handleScroll);
	}

	componentDidMount() {
		document.addEventListener('scroll', this.handleScroll);
		this.handleScroll();
	}

	render(): ReactElement {
		let props = Object.assign({}, this.props, {
			key: this.props.id + '.' + this.state + '.ImageBox'
		});
		let element = !isEven(this.props.i as number) && window.innerWidth > 480 && !isMobile()? [
			<ImageBox
				key={this.props.id + '.' + this.props.i + '.ImageBox'}
				image={this.props.image}
				style={Object.assign({}, props.style)}
			/>,
			<TextBox
				key={this.props.id + '.' + this.props.i + '.TextBox'}
				{...this.props}
			/>
		] : [
			<TextBox
				key={this.props.id + '.' + this.props.i + '.TextBox'}
				{...this.props}
			/>,
			<ImageBox
				{...props}
				style={Object.assign({}, props.style)}
			/>
		];
		return (
			<div
				className={[styles.post, styles['projects-text']].join(' ')}
				key={this.props.id}
				ref={this.container}
			>
				{element}
			</div>
		);
	}

}